<template>
  <div id="detail" v-cloak>
    <!-- 开启底部安全区适配 -->
    <van-number-keyboard safe-area-inset-bottom />

    <van-sticky class="tops">
      <div class="top">
        <div v-if="!showVideo">
          <img :src="theme.headimg" class="head-image" alt="" />
        </div>
        <div v-if="showVideo">
          <video-player :options="videoOptions" v-if="showVideo"></video-player>
        </div>
        <div class="count-down" v-if="!isStart || isEnd">
          <div v-if="!isStart && !isEnd">
            <van-count-down
              :time="countDownTime"
              format="距离直播开始还有 DD 天 HH 时 mm 分 ss 秒"
              @finish="finishCountDown"
            />
          </div>
          <!-- <div v-else>
            直播已结束<span v-if="theme.type == 2 && theme.revideo_src"
              >，可查看回放。</span
            >
          </div> -->
        </div>
        <div class="music" @click="playBgMusic" v-if="theme.musicfile">
          <van-icon
            class-prefix="iconfont"
            :name="playingBgMusic ? 'musicfill' : 'musicforbidfill'"
          ></van-icon>
        </div>
        <div class="view-zan">
          <div class="view">
            <van-icon name="friends-o" /> {{ theme.views + 1 }}人
          </div>
          <div class="z" @click="doLike">
            <van-icon name="like-o" /> {{ theme.likes }}
          </div>
        </div>
      </div>
      <div class="slow" v-if="slowVideos.length > 0">
        <div class="items">
          <div
            class="item"
            v-for="(v, k) in slowVideos"
            :key="k"
            :class="{ 'active-item': k == currentSlowItemIndex }"
            @click="switchSlowVideo(v, k)"
          >
            <img :src="v.poster" alt="" />
            <div class="title">{{ v.title }}</div>
          </div>
        </div>
      </div>

      <div class="tabs">
        <van-tabs v-model="activeTab" @click="switchTab">
          <van-tab
            v-for="(vv, kk) in theme.tabdata_array"
            :name="'tab' + kk"
            :title="vv"
            :key="kk"
          ></van-tab>
        </van-tabs>
      </div>

      <!-- 下边框 -->
      <div class="van-hairline--bottom"></div>
    </van-sticky>

    <div class="content">
      <div
        class="tent"
        v-show="activeTab == 'tab1' && theme.tabdata_array['1'] !== undefined"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="topicLoading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onTopicLoad"
          >
            <van-cell
              v-for="item in list"
              :key="item.id"
              @click.stop="doHideCommentInput"
            >
              <van-row class="topic">
                <van-col span="4" class="user-thumbnail">
                  <van-image
                    width="45"
                    height="45"
                    :src="item.livepersonal.avatar"
                    radius="5"
                    fit="cover"
                  ></van-image>
                </van-col>
                <van-col span="20" class="right">
                  <div class="name">
                    {{ item.livepersonal.title + " " + item.livepersonal.name }}
                  </div>
                  <div class="topic-content">{{ item.desc }}</div>
                  <div class="images" v-if="item.uploadimgs.length > 0">
                    <div class="one" v-if="item.uploadimgs.length == 1">
                      <img
                        v-lazy="item.uploadimgs[0]"
                        alt=""
                        @click="previewImage(0, item.uploadimgs)"
                      />
                    </div>
                    <div class="mult" v-else>
                      <van-grid square :column-num="3" :border="false">
                        <van-grid-item
                          v-for="(v, k) in item.uploadimgs"
                          :key="k"
                        >
                          <van-image
                            :src="v"
                            alt=""
                            height="100%"
                            fit="cover"
                            v-lazy="v"
                            @click="previewImage(k, item.uploadimgs)"
                          ></van-image>
                        </van-grid-item>
                      </van-grid>
                    </div>
                  </div>

                  <div class="time-more">
                    <div class="time">
                      {{ unixDate2Str(item.createtime * 1000) }}
                    </div>
                    <div class="more">
                      <van-icon
                        name="ellipsis"
                        size="20"
                        @click="showCaozuo(item.id)"
                      ></van-icon>
                      <transition name="van-slide-right">
                        <div
                          class="zan-comment"
                          v-show="curTopicId == item.id && showMore"
                          :id="'zan-comment-' + item.id"
                        >
                          <van-icon
                            :name="item.isZan ? 'like' : 'like-o'"
                            size="15"
                            @click="doZan(item)"
                            >&nbsp;<span v-if="item.isZan">取消</span
                            ><span v-else>赞</span></van-icon
                          >
                          <van-icon
                            name="comment"
                            size="15"
                            @click.stop="doShowCommentInput(item)"
                            >&nbsp;评论</van-icon
                          >
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div
                    class="zans-comments"
                    v-if="item.zans.length > 0 || item.comments.length > 0"
                  >
                    <div class="zans" v-if="item.zans.length > 0">
                      <van-icon name="like-o" size="15"></van-icon>&nbsp;
                      <span
                        class="zan-text"
                        v-for="(zan, z) in item.zans"
                        :key="z"
                      >
                        {{ zan.nick_name
                        }}<span v-if="item.zans.length > z + 1">,</span>
                      </span>
                      <!-- 下边框 -->
                      <div class="van-hairline--bottom"></div>
                    </div>
                    <div class="comments" v-if="item.comments.length > 0">
                      <div
                        class="one-comment"
                        v-for="(comment, com) in item.comments"
                        :key="com"
                      >
                        <span class="comment-name"
                          >{{ comment.nick_name }}:</span
                        >&nbsp;{{ comment.comment }}
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </van-pull-refresh>
        <div class="comment-input" v-show="showCommentInput">
          <div class="van-hairline--top"></div>
          <van-field
            v-model="commentWord"
            center
            clearable
            placeholder="请输入评论"
            ref="commentInput"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                :disabled="!commentWord"
                @click="sendComment"
                >发送</van-button
              >
            </template>
          </van-field>
        </div>

        <van-overlay
          :show="showQuickAdd"
          class="quick-add-overlay"
          @click="showQuickAdd = !showQuickAdd"
          :z-index="999"
        >
          <div class="form-zone" @click.stop>
            <div class="quick-title">快速发布</div>
            <van-form @submit="doQuickAdd">
              <van-field
                v-model="desc"
                label="内容"
                type="textarea"
                placeholder="请输入内容"
                required
                error
              />
              <van-field name="uploader" label="图片上传">
                <template #input>
                  <van-uploader
                    v-model="uploader"
                    multiple
                    :max-count="9"
                    upload-text="最多9张，单张不超过10MB"
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                  ></van-uploader>
                </template>
              </van-field>

              <div style="margin: 16px">
                <van-button
                  round
                  block
                  type="info"
                  native-type="submit"
                  :disabled="!desc"
                  >提交</van-button
                >
              </div>
            </van-form>
          </div>
        </van-overlay>
      </div>
      <div
        class="tent"
        v-show="activeTab == 'tab2' && theme.tabdata_array.hasOwnProperty(2)"
      >
        <div class="main-zone">
          <div class="desc-content" v-html="theme.desccontent"></div>
        </div>
      </div>
      <div
        class="tent"
        v-show="activeTab == 'tab3' && theme.tabdata_array.hasOwnProperty(3)"
      >
        <div class="main-zone" v-if="theme.qiandao_category_ids">
          <div v-if="!isSign">
            <van-form @submit="activeSign">
              <van-field
                readonly
                clickable
                :label="theme.qiandao_category.label"
                :value="school"
                :placeholder="'选择' + theme.qiandao_category.label"
                @click="showPickerItem = true"
              />
              <van-popup v-model="showPickerItem" round position="bottom">
                <van-picker
                  show-toolbar
                  :columns="qiandaoItems"
                  @cancel="showPickerItem = false"
                  @confirm="onConfirm"
                  value-key="text"
                />
              </van-popup>

              <div v-if="theme.qiandao_category.moredata === '1'">
                <van-field
                  v-model="class_"
                  :name="theme.qiandao_category.more_text"
                  :label="theme.qiandao_category.more_text"
                  :placeholder="theme.qiandao_category.more_text"
                  :rules="[
                    {
                      required: true,
                      message: '请填写' + theme.qiandao_category.more_text,
                    },
                  ]"
                />
              </div>
              <van-field
                v-model="trueName"
                name="姓名"
                label="姓名"
                placeholder="姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
              />

              <div style="margin: 16px">
                <van-button
                  round
                  block
                  type="info"
                  native-type="submit"
                  :disabled="!trueName || !school"
                  >提交</van-button
                >
              </div>
            </van-form>
          </div>
          <div v-else class="is-sign">
            <div class="sign-tag">
              <van-tag type="success" size="large"> 您已签到过了 </van-tag>
            </div>

            <van-cell-group>
              <van-cell
                :title="theme.qiandao_category.label"
                :value="signInfo.itemName"
              />
              <van-cell
                v-if="theme.qiandao_category.moredata === '1'"
                :title="theme.qiandao_category.more_text"
                :value="signInfo.banji"
              />
              <van-cell title="姓名" :value="signInfo.true_name" />
            </van-cell-group>
          </div>

          <!-- <div class="phb">
            <div class="title">
              <h4>排行榜</h4>
            </div>
            <div class="items">
              <div
                class="item van-hairline--bottom"
                v-for="(v, k) in phbs"
                :key="k"
              >
                <div>{{ v.name }}</div>
                <div>{{ v.c }}</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div
        class="tent"
        v-show="activeTab == 'tab4' && theme.tabdata_array.hasOwnProperty(4)"
      >
        <div class="main-zone">
          <div class="liuyan-zone">
            <div class="contents">
              <van-list
                ref="liuyanlist"
                v-model="liuyanLoading"
                :finished="liuyanFinished"
                finished-text="没有更多了"
                direction="up"
                :immediate-check="false"
                @load="onLoadLiuyan"
              >
                <div class="messages">
                  <div
                    class="one-message"
                    v-for="(v, k) in liuyans"
                    :key="k"
                    :class="{
                      'mine-message': v.user_id == zswlUser.id,
                      'other-message': v.user_id != zswlUser.id,
                    }"
                  >
                    <div class="head-image">
                      <img :src="v.zswluser.headimage" alt="" />
                    </div>
                    <div class="name-message">
                      <div
                        class="name"
                        :class="{
                          'text-right': v.user_id == zswlUser.id,
                          'text-left': v.user_id != zswlUser.id,
                        }"
                      >
                        {{ v.zswluser.nick_name }}
                      </div>
                      <div class="message">{{ v.message }}</div>
                    </div>
                  </div>
                </div>
              </van-list>
            </div>
            <div class="comment-input van-hairline--top">
              <div
                class="more-default-words"
                v-if="
                  theme.id == 3 ||
                  theme.id == 10 ||
                  theme.id == 14 ||
                  theme.id == 22 ||
                  theme.id == 28 ||
                  theme.id == 29 ||
                  theme.id == 33 ||
                  theme.id == 34 ||
                  theme.id == 38
                "
              >
                <van-popover
                  v-model="showDefaultWords"
                  trigger="click"
                  placement="top-start"
                >
                  <div
                    v-for="(va, ke) in defaultWords"
                    :key="ke"
                    @click="doDefaultWordsActions(va)"
                    class="default-word"
                  >
                    {{ va.text }}
                  </div>
                  <template #reference>
                    <van-icon name="more-o" size="30"></van-icon>
                  </template>
                </van-popover>
              </div>
              <van-field
                v-model="liuyanWord"
                center
                clearable
                placeholder="请输入内容"
                ref="commentInput"
                v-on:keyup.enter="sendLiuyan"
              >
                <template
                  #extra
                  v-if="
                    theme.id == 3 ||
                    theme.id == 10 ||
                    theme.id == 14 ||
                    theme.id == 22 ||
                    theme.id == 28 ||
                    theme.id == 29 ||
                    theme.id == 33 ||
                    theme.id == 34 ||
                    theme.id == 38
                  "
                >
                  <van-icon
                    name="gift"
                    size="30"
                    color="#ff6f22"
                    @click="showGiftModal = true"
                  ></van-icon>
                </template>
                <template #button>
                  <van-button
                    size="small"
                    type="primary"
                    :disabled="!liuyanWord"
                    @click="sendLiuyan"
                    >发送</van-button
                  >
                </template>
              </van-field>
            </div>

            <van-popup v-model="showGiftModal" class="gift-modal">
              <div class="title">我的奖品</div>
              <div class="prize">
                <span>{{ myPrize }}</span>
              </div>
            </van-popup>
          </div>
        </div>
      </div>

      <div
        class="tent"
        v-show="activeTab == 'tab5' && theme.tabdata_array.hasOwnProperty(5)"
      >
        <div class="main-zone">
          <div class="vote-zone">
            <div class="phb-btn">
              <van-button
                plain
                type="primary"
                size="mini"
                icon="descending"
                v-if="!showVotePhb"
                @click="showVotePhb = true"
                >查看排行榜</van-button
              >

              <van-button
                plain
                type="warning"
                size="mini"
                icon="revoke"
                v-else
                @click="showVotePhb = false"
                >返回投票</van-button
              >
            </div>
            <div v-show="showVotePhb">
              <div
                v-for="(v, k) in phbVotes"
                :key="v.id"
                :name="v.id"
                class="item"
              >
                <div class="flex">
                  <div class="left">
                    <van-image
                      width="100"
                      height="100"
                      :src="v.smallimage_text"
                      radius="8"
                      fit="cover"
                    ></van-image>
                  </div>
                  <div class="right">
                    <div class="title">
                      <van-tag type="danger" style="margin-right: 5px">{{
                        k + 1
                      }}</van-tag>
                      <van-tag type="danger">编号:{{ v.weigh }}</van-tag>
                      {{ v.title }}
                    </div>
                    <div class="unit">{{ v.unit }} - {{ v.name }}</div>
                    <div class="name">
                      <van-icon name="good-job">{{ v.vote }}</van-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="!showVotePhb">
              <div>
                <div v-for="v in votes" :key="v.id" :name="v.id" class="item">
                  <div class="flex">
                    <div class="left">
                      <van-image
                        width="100"
                        height="100"
                        :src="v.smallimage_text"
                        radius="8"
                        fit="cover"
                      ></van-image>
                    </div>
                    <div class="right">
                      <div class="title">
                        <van-tag type="danger">编号:{{ v.weigh }}</van-tag>
                        {{ v.title }}
                      </div>
                      <div class="unit">{{ v.unit }} - {{ v.name }}</div>
                      <div class="name">
                        <van-icon name="good-job">{{ v.vote }}</van-icon>
                        <van-button
                          size="mini"
                          type="info"
                          @click="onVote(v.id)"
                          :disabled="v.isVoted"
                          :text="v.isVoted ? '已投' : '投TA一票'"
                        ></van-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <van-popover
        v-model="showActions"
        theme="dark"
        trigger="click"
        :actions="actions"
        placement="left-end"
        @select="doActions"
      >
        <template #reference>
          <van-button icon="bars" type="info" size="small"></van-button>
        </template>
      </van-popover>
    </div>

    <van-overlay
      :show="showLottery"
      @click="showLottery = false"
      class="lottery"
    >
      <div class="wrapper" @click.stop>
        <LuckyWheel
          ref="myLucky"
          width="300px"
          height="300px"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
    </van-overlay>

    <van-overlay
      :show="showWinnerForm"
      class="winner-form-overlay quick-add-overlay"
      :z-index="999"
    >
      <div class="form-zone" @click.stop>
        <div class="quick-title">{{ afterReturnRand.msg }}</div>
        <div class="quick-sm">个人信息我们将严格保密，仅作兑奖凭证。</div>
        <van-form @submit="doSignWinner">
          <van-field
            v-model="winner.true_name"
            label="姓名"
            type="input"
            placeholder="请输入姓名"
            required
            error
          />

          <van-field
            v-model="winner.mobile"
            label="手机号码"
            type="input"
            placeholder="请输入手机号码"
            required
            error
          />

          <van-field
            v-model="winner.id_card"
            label="身份证号"
            type="input"
            placeholder="请输入身份证号"
            required
            error
          />

          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              :disabled="!winner.true_name || !winner.mobile || !winner.id_card"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import "@/assets/font/iconfont.css";
import VideoPlayer from "@/components/VideoPlayer.vue";
import Vue from "vue";
import config from "@/config";

import {
  getTheme,
  loadOldestTopics,
  onZan,
  delZan,
  addComment,
  loadComments,
  loadQiandaoItems,
  addSign,
  getSign,
  addTopic,
  getPersonal,
  loadNewestTopics,
  addViews,
  addLikes,
  loadSignPhb,
  addLiuyan,
  loadNewestLiuyans,
  loadOldestLiuyans,
  loadPrizies,
  getPrizeRand,
  addPrizeRecord,
  addPrizeWinner,
  getMyPrize,
  loadChildVideo,
  loadAllVoteItems,
  loadVoteRecord,
  addVoteRecord,
} from "@/api/live";
import {
  Toast,
  List,
  Sticky,
  Grid,
  GridItem,
  Row,
  Col,
  ImagePreview,
  Image,
  Lazyload,
  Icon,
  Field,
  Picker,
  Tag,
  Popover,
  Overlay,
  Uploader,
  CountDown,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
} from "vant";
import { unixDate2Str } from "@/utils/common";
import VueLuckyCanvas from "@lucky-canvas/vue";
Vue.use(Lazyload);
Vue.use(VueLuckyCanvas);

export default {
  name: "detail",
  components: {
    VideoPlayer,
  },
  data() {
    return {
      staticUrl:
        process.env.NODE_ENV === "development"
          ? config.staticUrl.dev
          : config.staticUrl.pro,
      activeTab: "tab2",
      theme: {
        tabdata_array: {},
        qiandao_category: {
          label: "",
        },
      },
      loading: false,
      topicLoading: false,
      list: [],
      finished: false,
      refreshing: false,
      page: 1,
      showMore: false,
      curTopicId: 0,
      zaning: false,
      zswlUser: this.$storage.get("zswlUser"),
      appUser: this.$storage.get("appUser"),
      commentWord: "",
      liuyanWord: "",
      showCommentInput: false,
      sending: false,
      curTopic: {},
      qiandaoItems: [],
      class_: "",
      trueName: "",
      doing: false,
      showPickerItem: false,
      school: "",
      schoolId: 0,
      curSchool: {},
      submiting: false,
      isSign: false,
      signInfo: {},
      showActions: false,
      actions: [
        // { text: '发布', action: 'quickAdd' },
        // { text: '绑定', action: 'bind' },
        // { text: '管理', action: 'manage' },
        { text: "刷新", action: "refresh" },
      ],
      showQuickAdd: false,
      uploader: [], // 快速发布框里的图片
      desc: "",
      imgFile: null,
      isBind: false,
      player: null,
      showVideo: false,
      videoOptions: {
        height: 230,
        autoplay: false,
        controls: true,
        poster: "",
        sources: [
          {
            // src: '//vjs.zencdn.net/v/oceans.mp4',
            type: "video/mp4",
            src: "",
            // type: ''
          },
        ],
      },
      phbs: [],
      countDownTime: 0,
      isStart: false,
      isEnd: false,
      liuyans: [],
      liuyanCount: 1,
      liuyanLoading: false,
      liuyanFinished: false,
      showDefaultWords: false,
      defaultWords: [],
      showLottery: false,
      blocks: [{ padding: "13px", background: "#FDE52D" }],
      prizes: [],
      buttons: [
        { radius: "50px", background: "#F87F02" },
        { radius: "45px", background: "#ffffff" },
        {
          radius: "40px",
          background: "#D43128",
          pointer: true,
          fonts: [{ text: "开始\n抽奖", top: "-20px" }],
        },
      ],
      lotterying: false,
      prizeRecord: {},
      afterReturnRand: {},
      showWinnerForm: false,
      winner: { true_name: "", mobile: "", id_card: "" },
      slowVideos: [],
      currentSlowItem: {},
      currentSlowItemIndex: -1,
      showGiftModal: false,
      myPrize: "很遗憾，您还没有奖品。",
      // 投票start
      votes: [],
      voting: false,
      showVotePhb: false,
      phbVotes: [],
      voteId: 0,
      votedIds: [],
      // 背景音乐start
      playingBgMusic: false,
      bgMusic: "",
    };
  },
  computed: {},
  mounted() {},
  watch: {
    activeTab(val, oldVal) {
      if (val == "tab4" && this.liuyanCount == 1) {
        this.$refs.liuyanlist.check();
      }
    },
    showVotePhb(val, oldVal) {
      this.onLoadVotes();
    },
  },
  created() {
    if (this.$route.params.id == 3) {
      this.defaultWords = [
        { text: "#许愿2022，温岭元素闪耀央视跨年晚会！" },
        { text: "#许愿2022，大海啊温岭，我一定会来瞧瞧的~" },
        { text: "#许愿2022，诗和远方，温岭都有。" },
        { text: "#许愿2022，愿新年，一路生花。" },
        { text: "#许愿2022，所爱如山海，所愿皆成真。" },
        { text: "#许愿2022，有趣有盼，不负心中热爱。" },
        { text: "#许愿2022，愿2022不慌不忙，皆心之所向。" },
        { text: "#许愿2022，送你一朵小红花，来年多喜乐。" },
        { text: "#许愿2022，新的一年，有温汤可享，有爱人在旁。" },
        { text: "#许愿2022，凛冬散尽，星河长明，新的一年，万事顺遂。" },
        { text: "#许愿2022，" },
      ];
    } else if (this.$route.params.id == 10) {
      this.defaultWords = [
        { text: "#春暖花开 春回大地山青水绿" },
        { text: "#春暖花开 迟日江山丽，春风花草香" },
        { text: "#春暖花开 最爱温岭美景" },
        { text: "#春暖花开 一起“云踏青”~" },
        { text: "#春暖花开  相逢一场不一样的“云踏青”" },
        { text: "#春暖花开  “云踏青”赏温岭春景" },
      ];
    } else if (this.$route.params.id == 14) {
      this.defaultWords = [
        { text: "#滩涂赶海，我们浪起~" },
        { text: "#海风微醺，滩涂赶海gogogo！" },
        { text: "#线上“云游”温岭秀丽山海风光！" },
        { text: "#大美温岭~" },
        { text: "#一起嗨，才够味！" },
      ];
    } else if (this.$route.params.id == 22) {
      this.defaultWords = [
        { text: "#远方不远，这里如诗~" },
        { text: "#我的诗和远方在温岭" },
        { text: "#大美温岭" },
        { text: "#跟着诗和远方打卡温岭" },
        { text: "#心中有诗和远方，在哪里都是享受" },
      ];
    } else if (this.$route.params.id == 28) {
      this.defaultWords = [
        { text: "#诗和远方，温岭都有！" },
        { text: "#《奶奶的旅行攻略》，欢迎再来温岭~" },
        { text: "#曙光首照地，东海好望角，温岭欢迎你！" },
        { text: "#在温岭，一起来一场浪漫的邂逅~" },
        { text: "#祝《奶奶的旅行攻略》，出圈上热搜！" },
        { text: "#跟着《奶奶的旅行攻略》云旅游，打卡赢好礼" },
        { text: "#温岭的山川与海，值得你按下一次次幸福的快门" },
      ];
    } else if (this.$route.params.id == 29) {
      this.defaultWords = [
        { text: "#这里是横峰，赞赞赞！" },
        { text: "#期待宗文中学建成" },
        { text: "#新校园新气象" },
        { text: "#我们一起来见证！" },
        { text: "#宗文中学“横”有看头" },
        { text: "#我为横峰点赞！" },
      ];
    } else if (this.$route.params.id == 33) {
      this.defaultWords = [
        { text: "#2023你好 加油，未来可期！" },
        { text: "#2023你好 新年新气象，一起追曙光！" },
        { text: "#2023你好 新的一年，我要暴富！" },
        { text: "#2023你好 年年欢喜 事事如意" },
        { text: "#2023你好 奔赴一场日出的浪漫，我来啦~" },
        { text: "#2023你好  新的一年，光明璀璨！" },
        { text: "#2023你好 凡是过往皆为序章，开启我的新旅程！" },
        { text: "#2023你好 愿前方光芒万丈，身后温暖一方" },
      ];
    } else if (this.$route.params.id == 34) {
      this.defaultWords = [
        { text: "#四季平安春常在，财源滚滚福年来" },
        { text: "#“兔”然暴富，钱“兔”无量" },
        { text: "#平安喜乐，万事胜意" },
        { text: "#2023年，祝朋友们好运“兔”来，扬眉“兔”气！" },
        { text: "#回首2022披荆斩棘，展望2023滚烫再出发！" },
        { text: "#一帆风顺吉星照，万事如意步步高" },
        { text: "#逛公园赏温岭，兔年大吉~ " },
      ];
    }else if (this.$route.params.id == 38) {
      this.defaultWords = [
        { text: "#山呼海应 心手相牵" },
        { text: "#温岭阆中奏响山海协作“共进曲”" },
        { text: "#从“牵手”到“拥抱” 东西协作共锦绣" },
        { text: "#温阆携手共建 向着美好的明天" },
        { text: "#跨越千里的“拥抱”" },
        { text: "#为温阆共建加油" },
        { text: "#天青色等烟雨，我在阆中等你" },
        { text: "#曙光首照地 东海好望角" },
      ];
    }

    this.onLoadPrize();
    addViews({ id: this.$route.params.id }).then((res) => {
      // console.log(res)
    });

    if (this.loading) return false;
    this.loading = true;

    getTheme({ id: this.$route.params.id }).then((res) => {
      if (res.code == 1) {
        let result = res.data;
        this.theme = result;

        this.activeTab = "tab" + this.theme.current_tabdata;

        // 计算直播开始和结束时间
        let now = new Date();
        this.countDownTime = result.starttime * 1000 - now;
        // this.countDownTime = 5 * 1000
        this.isStart = this.countDownTime <= 0;
        this.isEnd = now - result.endtime * 1000 > 0;

        if (result.type == 2) {
          if (
            (this.isStart && result.video_src) ||
            (this.isEnd && result.revideo_src)
          ) {
            this.showVideo = true;
          }
        }

        if (result.type == "2" || result.video_src || result.revideo_src) {
          this.videoOptions.poster = result.headimg;
          let video_src = "";
          if (this.isEnd && result.revideo_src) {
            video_src = result.revideo_src;
            // video_src = result.revideo_src.toLowerCase();
          } else {
            video_src = result.video_src;
            // video_src = result.video_src.toLowerCase();
          }
          if (/^http:\/\/?/.test(video_src)) {
            video_src = video_src.replace(/^http:?/, "");
          }

          if (/\.m3u8?/.test(video_src)) {
            this.videoOptions.sources = [
              {
                src: video_src,
                type: "application/x-mpegURL",
              },
            ];
          } else {
            this.videoOptions.sources = [
              {
                src: video_src,
                type: "video/mp4",
              },
            ];
          }

          /*
          if (this.isEnd) {
            this.slowVideos.push({
              text: '瞻温岭',
              src: video_src,
              poster: result.headimg,
              isStart: false
            })
          } else {
            this.slowVideos.unshift({
              text: '瞻温岭',
              src: video_src,
              poster: result.headimg,
              isStart: this.isStart
            })
          }
          */
        }

        document.title = result.title;

        if (result.musicfile_url) {
          this.initBgMusic(result.musicfile_url);
        }

        this.setShare();
        // console.log(result.tabdata_array);
        // 如果有图文
        if ("1" in result.tabdata_array) {
          this.actions.unshift(
            { text: "发布", action: "quickAdd" },
            { text: "绑定", action: "bind" }
            // { text: '管理', action: 'manage' }
          );
          this.onTopicLoad();
        }

        // 如果有投票，加载投票信息
        if ("5" in result.tabdata_array) {
          this.onLoadVotes().then(() => {
            loadVoteRecord({
              theme_id: this.$route.params.id,
              vote_id: this.voteId,
            }).then((res) => {
              if (res.code == 1) {
                this.votedIds = res.data;
                this.votes.map((v) => {
                  // console.log(votedIds.includes(v.id))
                  if (this.votedIds.includes(v.id)) {
                    this.$set(v, "isVoted", true);
                  }
                });
              }
            });
          });
        }

        if (this.theme.qiandao_category_ids) {
          getSign({
            theme_id: this.$route.params.id,
            user_id: this.zswlUser.id,
          }).then((res) => {
            if (res.code == 1) {
              let isSign = res.data.is_sign;
              this.isSign = isSign;
              if (!isSign) {
                loadQiandaoItems({
                  qiandao_category_id: this.theme.qiandao_category_ids,
                }).then((re) => {
                  if (re.code == 1) {
                    let result = re.data;
                    let rows = result.rows;
                    rows.forEach((row) => {
                      this.qiandaoItems.push({ text: row.name, id: row.id });
                    });
                    // this.qiandaoItems = result.rows
                  }
                });
              } else {
                let sign = res.data.sign;
                sign.itemName = sign.liveqiandaoitem.name;
                this.signInfo = sign;
              }

              // 获得排行榜
              // loadSignPhb({
              //   qiandao_category_id: this.theme.qiandao_category_ids,
              //   theme_id: this.theme.id
              // }).then((res) => {
              //   if (res.code == 1) {
              //     this.phbs = res.data
              //   } else {
              //     Toast.fail(res.msg)
              //   }
              // })
            }
          });
        }
      } else {
        Toast.fail(res.msg);
      }
      this.loading = false;
    });

    loadChildVideo({ theme_id: this.$route.params.id }).then((res) => {
      if (res.code == 1) {
        this.slowVideos = res.data.rows;
      }
    });

    getPersonal({
      theme_id: this.$route.params.id,
      user_id: this.zswlUser.id,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data == 1) {
          this.isBind = true;
        }
      }
    });
  },
  methods: {
    switchTab(name, title) {
      if (name == "tab4" && this.liuyanCount == 1) {
        this.$refs.liuyanlist.check();
      }
    },
    switchSlowVideo(slow, index) {
      // console.log(slow)
      if (this.currentSlowItemIndex == index) return false;

      this.currentSlowItem = slow;
      this.currentSlowItemIndex = index;

      this.videoOptions.poster = slow.poster;
      let video_src = slow.url;
      // let video_src = slow.url.toLowerCase();

      if (/^http:\/\/?/.test(video_src)) {
        video_src = video_src.replace(/^http:?/, "");
      }

      if (/\.m3u8?/.test(video_src)) {
        this.videoOptions.sources = [
          {
            src: video_src,
            type: "application/x-mpegURL",
          },
        ];
      } else {
        this.videoOptions.sources = [
          {
            src: video_src,
            type: "video/mp4",
          },
        ];
      }
      this.showVideo = false;
      this.isStart = false;
      this.$nextTick(() => {
        this.showVideo = true;
        // this.isStart = slow.isStart
        this.isStart = true;
      });
    },
    doSignWinner() {
      if (this.submiting) return false;
      this.submiting = true;

      let data = this.winner;
      data.prize_id = this.afterReturnRand.data.prize_id;
      // data.prize_id = 3
      data.theme_id = this.theme.id;
      addPrizeWinner(data).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          Toast.success(res.msg);
          this.showWinnerForm = false;
        } else {
          Toast.fail(res.msg);
        }

        this.submiting = false;
      });
    },
    doAddPrizeRecord() {
      addPrizeRecord({ theme_id: this.$route.params.id }).then((res) => {
        // console.log('addpr', res)
        if (res.code == 1) {
          let record = res.data.record;
          this.prizeRecord = record;
          if (record.status == "0") {
            this.showLottery = true;
          }
        }
      });
    },
    onLoadPrize() {
      loadPrizies({ theme_id: this.$route.params.id }).then((res) => {
        if (res.code == 1) {
          let results = res.data.rows;
          results.forEach((v, k) => {
            let prize = {
              fonts: [
                { text: v.title, top: "10%", fontSize: 16, lengthLimit: 80 },
              ],
            };
            if (k % 2 == 0) {
              prize.background = "#FFF4D6";
            } else {
              prize.background = "#FFFFFF";
            }
            this.prizes.push(prize);
          });
        }
      });

      getMyPrize({ theme_id: this.$route.params.id }).then((res) => {
        if (res.code == 1) {
          let data = res.data;
          if (data) {
            this.myPrize = data.liveprize.title;
          } else {
            this.myPrize = res.msg;
          }
        }
      });
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.lotterying) return false;
      this.lotterying = true;

      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();

      getPrizeRand({
        theme_id: this.$route.params.id,
        record_id: this.prizeRecord.id,
      }).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          let result = res.data;

          const index = result.index;
          // 调用stop停止旋转并传递中奖索引
          this.$refs.myLucky.stop(index);

          this.afterReturnRand = res;
        } else {
          Toast.fail(res.msg);
        }
        this.lotterying = false;
      });
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      // console.log('end', prize)
      this.prizeRecord.status = "1";
      let result = this.afterReturnRand.data;
      if (result.is_win) {
        // 中奖了，信息登记
        Toast.success(this.afterReturnRand.msg);
        this.showLottery = false;
        this.myPrize = result.title;
        this.$nextTick(() => {
          this.showWinnerForm = true;
        });
      } else {
        this.showLottery = false;
        Toast({ message: this.afterReturnRand.msg, duration: 4000 });
      }
    },
    onLoadNewestLiuyan() {
      if (this.liuyanLoading) return false;
      let params = {};

      const lastLiuyan = this.liuyans[0];
      params = {
        theme_id: this.$route.params.id,
        order: "desc",
        last_id: lastLiuyan ? lastLiuyan.id : 0,
      };

      loadNewestLiuyans(params).then((res) => {
        this.liuyanLoading = false;
        if (res.code == 1) {
          let results = res.data.rows;
          if (results.length <= 0) {
            this.liuyanFinished = true;
          }

          results.forEach((v, k) => {
            this.liuyans.unshift(v);
          });

          this.liuyanCount++;
          this.$nextTick(() => {
            if (this.liuyanCount < 3) {
              window.scrollTo(0, document.body.scrollHeight);
            } else {
              window.scrollTo(0, 1500);
            }
          });
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onLoadLiuyan() {
      // if (this.liuyanLoading) return false
      let params = {};
      if (this.liuyanCount == 1) {
        params = {
          theme_id: this.$route.params.id,
          page: this.liuyanCount,
          order: "desc",
          last_id: 0,
        };
      } else {
        const lastLiuyan = this.liuyans[0];
        params = {
          theme_id: this.$route.params.id,
          order: "desc",
          last_id: lastLiuyan.id,
        };
      }
      loadOldestLiuyans(params).then((res) => {
        this.liuyanLoading = false;
        if (res.code == 1) {
          let results = res.data.rows;
          if (results.length <= 0) {
            this.liuyanFinished = true;
          }

          results.forEach((v, k) => {
            this.liuyans.unshift(v);
          });

          this.liuyanCount++;
          this.$nextTick(() => {
            if (this.liuyanCount < 3) {
              window.scrollTo(0, document.body.scrollHeight);
            } else {
              window.scrollTo(0, 1500);
            }
          });
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    finishCountDown() {
      this.isStart = true;
      if (this.theme.type == 2) {
        this.showVideo = true;
      }
    },
    initBgMusic(musicUrl) {
      console.log("mm", musicUrl);
      this.bgMusic = new Audio();
      this.bgMusic.loop = true;
      this.bgMusic.autoplay = true;
      this.bgMusic.crossOrigin = "anonymous";

      this.bgMusic.addEventListener("error", function (e) {
        console.log("nn", e);
      });

      this.bgMusic.src = musicUrl;
      this.bgMusic.play();

      this.playingBgMusic = true;
    },
    playBgMusic() {
      if (this.playingBgMusic) {
        this.bgMusic.pause();
      } else {
        this.bgMusic.play();
      }
      this.playingBgMusic = !this.playingBgMusic;
    },
    setShare() {
      let self = this;
      CP.setShare({
        completed: function (data) {
          // data > {success:'1'}
          CP.tools.writelog("set_share", data);
        },
        cpIncompatible: function () {
          CP.tools.writelog("", "此环境不支持此方法");
        },
        title: self.theme.title,
        shareTo: "",
        link: window.location.href,
        imgUrl: self.theme.shareimg,
        shareSummary: self.share_desc,
        success: function () {
          console && console.log("用户已分享");
        },
      });
    },
    doLike() {
      addLikes({ id: this.$route.params.id }).then((res) => {
        if (res.code == 1) {
          this.theme.likes++;
        }
      });
    },
    beforeDelete() {
      // this.uploader = []
      console.log("beforeDelete");
      // this.imgFile = null
    },
    onOversize(file) {
      // console.log(file)
      Toast.fail("文件大小不能超过 10MB");
    },
    doQuickAdd() {
      if (this.submiting) return false;
      this.submiting = true;

      const toast = Toast.loading({
        message: "正在发布中...",
        forbidClick: true,
        duration: 0,
      });

      this.uploader.forEach((v, k) => {
        const file = {
          name: v.file.name,
          size: v.file.size,
          type: v.file.type,
        };
        v.file = file;
      });
      // console.log(this.uploader)

      let params = {
        desc: this.desc,
        theme_id: this.theme.id,
        user_id: this.zswlUser.id,
        uploadimages: this.uploader,
      };
      // console.log(params)
      addTopic(params).then((res) => {
        // console.log(res)
        Toast.clear();
        if (res.code == 1) {
          Toast.success(res.msg);
          this.list.unshift(res.data.topic);
          this.showQuickAdd = false;
          this.desc = "";
          this.uploader = [];
        } else {
          Toast.fail(res.msg);
        }
        this.submiting = false;
      });
    },
    doDefaultWordsActions(action) {
      this.liuyanWord = action.text;
      this.showDefaultWords = false;
    },
    doActions(action, index) {
      if (action.action == "quickAdd") {
        if (this.isBind) {
          this.showQuickAdd = true;
        } else {
          Toast.fail("您还没有绑定，请先去绑定");
        }
      } else if (action.action == "bind") {
        this.$router.push({ path: "/live/bind/" + this.$route.params.id });
      } else if (action.action == "refresh") {
        window.location.reload();
      } else {
        Toast("coming soon");
      }
      // console.log(action, index)
    },
    activeSign() {
      if (this.submiting) return false;
      this.submiting = true;

      let params = {
        theme_id: this.theme.id,
        item_id: this.curSchool.id,
        true_name: this.trueName,
        banji: this.class_,
        telephone: this.zswlUser.mobile,
        qiandao_category_id: this.theme.qiandao_category_ids,
        user_id: this.zswlUser.id,
      };
      addSign(params).then((res) => {
        if (res.code == 1) {
          Toast.success(res.msg);
          this.isSign = true;
          params.itemName = this.school;
          this.signInfo = params;
        } else {
          Toast.fail(res.msg);
        }
        this.submiting = false;
      });
    },
    onConfirm(value) {
      this.curSchool = value;
      this.school = value.text;
      this.showPickerItem = false;
    },
    sendLiuyan() {
      if (this.sending || !this.liuyanWord) return false;
      this.sending = true;

      let data = { theme_id: this.theme.id, message: this.liuyanWord };
      addLiuyan(data).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          Toast.success(res.msg);
          data.user_id = this.zswlUser.id;
          this.zswlUser.headimage = this.appUser.head_img;
          data.zswluser = this.zswlUser;
          this.liuyans.push(data);
          this.liuyanWord = "";
          this.$nextTick(() => {
            window.scrollTo(0, document.body.offsetHeight);
          });

          if (
            this.$route.params.id == 3 ||
            this.$route.params.id == 10 ||
            this.$route.params.id == 14 ||
            this.$route.params.id == 22 ||
            this.$route.params.id == 28 ||
            this.$route.params.id == 33 ||
            this.$route.params.id == 34 ||
            this.$route.params.id == 38
          ) {
            if (this.prizeRecord.status != undefined) {
              if (this.prizeRecord.status == "0") {
                this.showLottery = true;
              }
            } else {
              this.doAddPrizeRecord();
            }
          }
        } else {
          Toast.fail(res.msg);
        }
        this.sending = false;
      });
    },
    sendComment() {
      if (!this.commentWord || this.sending) return false;
      this.sending = true;

      let params = {
        topic_id: this.curTopic.id,
        user_id: this.zswlUser.id,
        theme_id: this.theme.id,
        comment: this.commentWord,
      };
      addComment(params).then((res) => {
        if (res.code == 1) {
          Toast.success(res.msg);
          params.nick_name = this.zswlUser.nick_name;
          this.curTopic.comments.push(params);
          this.doHideCommentInput();
        } else {
          Toast.fail(res.msg);
          // this.doHideCommentInput()
        }
        this.sending = false;
      });
    },
    doHideCommentInput() {
      if (this.showCommentInput) {
        this.showCommentInput = false;
        this.commentWord = "";
      }
    },
    doShowCommentInput(topic) {
      this.commentWord = "";
      this.curTopic = topic;
      this.showCaozuo(topic.id);
      this.showCommentInput = true;
      this.$nextTick(() => this.$refs.commentInput.focus());
    },
    doZan(topic) {
      if (this.zaning) return false;
      this.zaning = true;

      let params = { theme_id: this.theme.id, topic_id: topic.id };
      if (topic.isZan) {
        // 已赞，执行取消
        delZan(params).then((res) => {
          if (res.code == 1) {
            topic.isZan = false;
            this.showCaozuo(topic.id);
            topic.zans.some((zan, za) => {
              if (zan.user_id == this.zswlUser.id) {
                topic.zans.splice(za, 1);
                return true;
              }
            });
            Toast.success(res.msg);
          } else {
            Toast.fail(res.msg);
            this.showCaozuo(topic.id);
          }
          this.zaning = false;
        });
      } else {
        // 未赞，执行点赞
        onZan(params).then((res) => {
          if (res.code == 1) {
            topic.isZan = true;
            this.showCaozuo(topic.id);
            let newZan = this.zswlUser;
            newZan.user_id = this.zswlUser.id;
            topic.zans.push(newZan);
            Toast.success(res.msg);
          } else {
            Toast.fail(res.msg);
            this.showCaozuo(topic.id);
          }
          this.zaning = false;
        });
      }
    },
    doComment(id) {},
    showCaozuo(id) {
      if (this.curTopicId == 0 || this.curTopicId == id) {
        this.showMore = !this.showMore;
      } else {
        this.showMore = true;
      }
      this.curTopicId = id;
    },
    unixDate2Str,
    previewImage(index, images) {
      ImagePreview({
        images,
        startPosition: index,
      });
    },
    onTopicLoad() {
      let params = {};
      if (this.page == 1) {
        params = {
          theme_id: this.$route.params.id,
          page: this.page,
          order: "desc",
          last_id: 0,
        };
      } else {
        const lastTopic = this.list.slice(-1);
        // console.log(lastTopic)
        params = {
          theme_id: this.$route.params.id,
          order: "desc",
          last_id: lastTopic[0].id,
        };
      }

      loadOldestTopics(params).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          let result = res.data.rows;
          let count = result.length;
          if (count > 0) {
            result.forEach((v, k) => {
              v.zans.forEach((zan, za) => {
                if (zan.user_id == this.zswlUser.id) {
                  v.isZan = true;
                }
              });
              this.list.push(v);
            });
            this.page++;
          } else {
            this.finished = true;
          }
        }
        this.topicLoading = false;
      });
    },
    onRefresh() {
      // 将大于最新一条的话题加载出来
      if (this.loading) return false;
      this.loading = true;
      // 拿到最近的一条的id
      let lastTopic = this.list[0];

      loadNewestTopics({
        theme_id: this.$route.params.id,
        last_id: lastTopic.id,
        order: "asc",
      }).then((res) => {
        if (res.code == 1) {
          let result = res.data.rows;
          result.forEach((v, k) => {
            v.zans.forEach((zan, za) => {
              if (zan.user_id == this.zswlUser.id) {
                v.isZan = true;
              } else {
                v.isZan = false;
              }
            });
            this.list.unshift(v);
          });
        }
        this.loading = false;
        this.refreshing = false;
      });
    },
    onVote(voteItemId) {
      if (this.voting) return false;

      this.voting = true;

      addVoteRecord({
        theme_id: this.$route.params.id,
        vote_item_id: voteItemId,
        vote_id: this.voteId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.votes.map((v) => {
              if (v.id == voteItemId) {
                v.vote++;
                v.isVoted = true;
              }
            });
            Toast.success(res.msg);
          } else {
            Toast.fail(res.msg);
          }
          this.voting = false;
        })
        .catch((err) => {
          console.log(err);
          this.voting = false;
        });
    },
    async onLoadVotes() {
      return new Promise((reslove, reject) => {
        loadAllVoteItems({
          theme_id: this.$route.params.id,
          sort: "ASC",
          order: "id",
        }).then((res) => {
          if (res.code == 1) {
            this.votes = res.data.rows;
            this.voteId = res.data.rows[0].vote_id;
            this.phbVotes = JSON.parse(JSON.stringify(res.data.rows));
            const arr = this.phbVotes.sort((a, b) => {
              return b.vote - a.vote;
            });
            if (this.votedIds.length > 0) {
              this.votes.map((v) => {
                if (this.votedIds.includes(v.id)) {
                  this.$set(v, "isVoted", true);
                }
              });
            }
          }
          reslove(true);
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.tops {
  /deep/ .van-sticky {
    background-color: #fff !important;
  }
  .top {
    position: relative;
    background-color: #fff;
    .head-image {
      width: 100%;
    }
    .music {
      z-index: 99;
      position: absolute;
      left: 5px;
      top: 5px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      line-height: 16px;
      padding: 0 5px;
    }
    .view-zan {
      z-index: 99;
      display: flex;
      position: absolute;
      right: 5px;
      top: 5px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 12px;
      line-height: 16px;
      padding: 0 5px;
      .view {
        margin-right: 5px;
      }
    }
    .count-down {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 5px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      padding: 1px 5px 1px 0;
    }
  }

  .slow {
    overflow: hidden;
    margin-top: 5px;
    .items {
      display: inline-flex;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;

      background-color: #fff;
      .item {
        position: relative;
        flex-shrink: 0;
        width: 90px;
        height: 50px;
        margin-right: 5px;
        margin-left: 5px;
        img {
          border-radius: 5px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .title {
          position: absolute;
          left: 5px;
          top: 5px;
          color: #fff;
          font-size: 12px;
        }
      }
      .active-item {
        border: 1px solid #0091ff;
        border-radius: 5px;
      }
    }
  }
}

.content {
  // min-height: 60vh;
  background-color: #f7f7f7;
  .tent {
    // height: 100%;
    .main-zone {
      height: 100%;
      padding: 10px 16px;

      .is-sign {
        .sign-tag {
          text-align: center;
          margin: 20px 0;
        }
      }
      .phb {
        .title {
          text-align: center;
        }
        .items {
          width: 50vw;
          margin: auto;
          .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px;
          }
        }
      }
      .desc-content {
        /deep/ p {
          margin: 2px 0 !important;
        }
        /deep/ img {
          max-width: 100% !important;
        }
      }
      .liuyan-zone {
        background-color: #f7f7f7;
        padding-bottom: 60px;
        .contents {
          .messages {
            min-height: 40vh;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .one-message {
              display: flex;
              margin-top: 20px;
              .head-image {
                width: 25px;
                img {
                  width: 100%;
                }
                margin: 0 5px;
              }
              .name-message {
                display: inline-grid;
                .name {
                  display: inline-block;
                  font-size: 12px;
                }
                .message {
                  display: inline-block;
                  margin-top: 5px;
                  background-color: rgba(255, 255, 255, 0.7);
                  color: #000;
                  border-radius: 5px;
                  padding: 2px 5px;
                  font-size: 14px;
                }
                .text-left {
                  text-align: left;
                }
                .text-right {
                  text-align: right;
                }
              }
            }
            .mine-message {
              flex-flow: row-reverse;
            }
          }
        }
        .gift-modal {
          min-width: 70vw;
          text-align: center;
          padding: 10px;
          .title {
            color: #ff6f22;
            font-size: 1.2rem;
            font-weight: bold;
          }
          .prize {
            margin-top: 10px;
          }
        }
      }

      .vote-zone {
        background-color: #fff;
        .phb-btn {
          text-align: right;
          margin-bottom: 5px;
          padding-top: 5px;
          padding-right: 5px;
        }
        .item {
          padding: 0 10px;
          margin-bottom: 10px;
          .flex {
            display: flex;
            padding: 5px 0;
            .right {
              margin-left: 8px;
              padding: 2px 0;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              flex: 1;
              .unit {
                font-size: 12px;
                color: #797471;
              }
              .name {
                font-size: 14px;
                color: #ff6f22;
                display: flex;
                justify-content: space-between;
              }
            }
          }
        }
      }
    }
  }
}

.topic {
  .user-thumbnail {
    img {
      width: 100%;
    }
  }
  .right {
    .name {
      color: #546590;
      font-weight: bold;
    }
    .topic-content {
      font-size: 16px;
    }
    .images {
      .one {
        width: 50%;
        max-height: 120px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .time-more {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .more {
        position: relative;
        .zan-comment {
          position: absolute;
          right: 20px;
          top: -6px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 140px;
          background-color: #4a4c4b;
          color: #fff;
          border-radius: 5px;
          line-height: 30px;
          height: 30px;
        }
      }
    }
    .zans-comments {
      background-color: #f7f7f7;
      padding: 0 5px 5px 5px;
      .zans {
        color: #546590;
        line-height: 18px;
      }
      .comments {
        .comment-name {
          color: #546590;
        }
      }
    }
  }
}

.comment-input {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #f7f7f7;
  padding: 5px 10px;
}

.default-word {
  padding: 3px 5px;
  font-size: 12px;
}

.actions {
  position: fixed;
  right: 16px;
  bottom: 10%;
}

.quick-add-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .form-zone {
    width: 85vw;
    background-color: #fff;
    padding: 10px 0;
    border-radius: 10px;
    .quick-title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .quick-sm {
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}

.lottery {
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
